import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Space, Spin } from 'antd';
import { BaseQuestionEdit } from '../base-question';
import { useForm } from 'antd/lib/form/Form';
import { QuestionFieldType } from '@module/form';
import styled from 'styled-components';
import { NumberInput, TextLinkButton, TextOptionInput } from '@lib/common';
import { styleVariables } from '@lib/common';
import { PlusCircleOutlined } from '@ant-design/icons';
import { isEqual } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var QuizEditStatus;

(function (QuizEditStatus) {
  QuizEditStatus[QuizEditStatus["EXECUTE"] = 1] = "EXECUTE";
  QuizEditStatus[QuizEditStatus["SUCCESS"] = 2] = "SUCCESS";
  QuizEditStatus[QuizEditStatus["ERROR"] = 3] = "ERROR";
  QuizEditStatus[QuizEditStatus["RESET"] = 4] = "RESET";
})(QuizEditStatus || (QuizEditStatus = {}));

var SpinLayout = styled.div.withConfig({
  displayName: "editcomponent__SpinLayout",
  componentId: "sc-miljl1-0"
})(["justify-content:center;text-align:center;align-items:center;margin-top:16px;"]);
var CorrectAnswerListField = styled(Form).withConfig({
  displayName: "editcomponent__CorrectAnswerListField",
  componentId: "sc-miljl1-1"
})(["margin-left:8px;"]);
var AnswerDescription = styled(CorrectAnswerListField.Item).withConfig({
  displayName: "editcomponent__AnswerDescription",
  componentId: "sc-miljl1-2"
})(["span.ant-input-affix-wrapper{height:42px;}"]);
var CorrectAnswerListContainer = styled.div.withConfig({
  displayName: "editcomponent__CorrectAnswerListContainer",
  componentId: "sc-miljl1-3"
})(["display:flex;text-align:center;"]);
var CorrectAnswerItemContainer = styled(Space).withConfig({
  displayName: "editcomponent__CorrectAnswerItemContainer",
  componentId: "sc-miljl1-4"
})(["display:flex;&:nth-child(1){flex:4;margin-right:8px;align-items:center;.ant-space-item{&:nth-child(2){width:100%;}}}&:nth-child(2){flex:1;}"]);
var CorrectAnswerNumber = styled.span.withConfig({
  displayName: "editcomponent__CorrectAnswerNumber",
  componentId: "sc-miljl1-5"
})(["color:", ";min-width:20px;font-size:16px;"], styleVariables.colors.blue4);
var ButtonAddMoreAnswer = styled(TextLinkButton).withConfig({
  displayName: "editcomponent__ButtonAddMoreAnswer",
  componentId: "sc-miljl1-6"
})(["color:", " !important;font-weight:500;font-size:14px;&:hover,&:focus{color:", ";}"], styleVariables.colors.blue4, styleVariables.colors.blue3);
var AddingIcon = styled(PlusCircleOutlined).withConfig({
  displayName: "editcomponent__AddingIcon",
  componentId: "sc-miljl1-7"
})(["margin-right:10px;"]);
var QuestionContentTitle = styled.div.withConfig({
  displayName: "editcomponent__QuestionContentTitle",
  componentId: "sc-miljl1-8"
})(["font-size:14px;font-weight:600;&:nth-child(1){flex:4;}&:nth-child(2){flex:1;}"]);
var Content = styled(Space).withConfig({
  displayName: "editcomponent__Content",
  componentId: "sc-miljl1-9"
})(["width:100%;* > .ant-form-item{margin-bottom:0;}"]);
var InputArea = styled(Space).withConfig({
  displayName: "editcomponent__InputArea",
  componentId: "sc-miljl1-10"
})(["width:100%;"]);
var QuestionTitleContainer = styled.div.withConfig({
  displayName: "editcomponent__QuestionTitleContainer",
  componentId: "sc-miljl1-11"
})(["display:flex;justify-content:space-between;"]);
export var FillInBlankEdit = function FillInBlankEdit(props) {
  var question = props.question,
      index = props.index,
      isDisabledInputs = props.isDisabledInputs,
      onDelete = props.onDelete,
      onUpdate = props.onUpdate,
      onUpdateType = props.onUpdateType,
      onCreateAnswer = props.onCreateAnswer,
      createAnswerStatus = props.createAnswerStatus,
      onResetCreateAnswer = props.onResetCreateAnswer,
      onDeleteAnswer = props.onDeleteAnswer,
      deleteAnswerStatus = props.deleteAnswerStatus,
      updateCorrectAnswerStatus = props.updateCorrectAnswerStatus,
      onResetDeleteAnswer = props.onResetDeleteAnswer,
      onUpdateAnswer = props.onUpdateAnswer,
      onUpdateCorrectAnswer = props.onUpdateCorrectAnswer,
      defaultDescription = props.defaultDescription;

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0];

  var setFieldsValue = form.setFieldsValue;

  var _useState = useState({}),
      isDeletingMap = _useState[0],
      setIsDeletingMap = _useState[1];

  var correctAnswersFormProps = useMemo(function () {
    var a = _objectSpread(_objectSpread({}, question.toJsonObject()), {}, {
      correctAnswers: question.correctAnswers.map(function (c) {
        return {
          id: c.id.toString(),
          answerDescription: question.answers.find(function (a) {
            return a.id.toString() === c.answerId;
          }).description,
          answerId: c.answerId,
          answerScore: c.score,
          index: c.index
        };
      })
    });

    return a; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question, question.correctAnswers, question.description, isEqual]);
  useEffect(function () {
    form.setFieldsValue({
      score: question.score
    });
  }, [form, question.score]);
  useEffect(function () {
    if (updateCorrectAnswerStatus === QuizEditStatus.SUCCESS) {
      setFieldsValue(correctAnswersFormProps);
    } else if (createAnswerStatus === QuizEditStatus.SUCCESS) {
      setFieldsValue(correctAnswersFormProps);
      createAnswerStatus && onResetCreateAnswer();
    } else if (deleteAnswerStatus === QuizEditStatus.SUCCESS) {
      setIsDeletingMap({});
      setFieldsValue(correctAnswersFormProps);
      deleteAnswerStatus && onResetDeleteAnswer();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [createAnswerStatus, deleteAnswerStatus, updateCorrectAnswerStatus, onResetCreateAnswer, onResetDeleteAnswer, setFieldsValue]);
  var onFieldsChange = useCallback(function (e) {
    var _e = _slicedToArray(e, 1),
        infoChange = _e[0];

    if (infoChange) {
      var name = infoChange.name,
          _value = infoChange.value;

      if (_value) {
        var _name = _slicedToArray(name, 1),
            _field = _name[0];

        if (_field === QuestionFieldType.type) {
          return onUpdateType(question.id.toString(), _value);
        }

        if (_field === QuestionFieldType.correctAnswers) {
          var _name2 = _slicedToArray(name, 3),
              _index = _name2[1],
              _field2 = _name2[2];

          if (_field2 === QuestionFieldType.answerDescription) {
            return onUpdateAnswer(_index, _value);
          }

          return onUpdateCorrectAnswer(_index, _value, _field2);
        }

        if (_field === QuestionFieldType.explanation) return;
        return onUpdate(question.id.toString(), _field, _value);
      }
    }
  }, [onUpdate, onUpdateAnswer, onUpdateCorrectAnswer, onUpdateType, question]);

  var handleAnswerInputFocus = function handleAnswerInputFocus(inputValue, answerIndex) {
    var defaultAnswerText = "Nh\u1EADp c\xE2u tr\u1EA3 l\u1EDDi";
    var isDefaultAnswerText = inputValue === defaultAnswerText;

    if (isDefaultAnswerText) {
      var _form$getFieldsValue = form.getFieldsValue(),
          correctAnswers = _form$getFieldsValue.correctAnswers;

      correctAnswers[answerIndex].answerDescription = '';
      form.setFieldsValue({
        correctAnswers: correctAnswers
      });
    }
  };

  var handleAnswerInputBlur = function handleAnswerInputBlur(inputValue, answerIndex) {
    var isEmptyInputValue = !inputValue.length;

    if (isEmptyInputValue) {
      var _form$getFieldsValue2 = form.getFieldsValue(),
          correctAnswers = _form$getFieldsValue2.correctAnswers;

      var defaultAnswerText = defaultDescription;
      correctAnswers[answerIndex].answerDescription = defaultAnswerText;
      form.setFieldsValue({
        correctAnswers: correctAnswers
      });
      onUpdateAnswer(answerIndex, defaultAnswerText);
    }
  };

  return /*#__PURE__*/_jsx(Form, {
    form: form,
    name: "question-essay-form",
    initialValues: correctAnswersFormProps,
    onFieldsChange: onFieldsChange,
    children: /*#__PURE__*/_jsx(BaseQuestionEdit, _objectSpread(_objectSpread({}, props), {}, {
      form: form,
      question: question,
      index: index,
      onDelete: onDelete,
      explainDisabled: true,
      onUpdateExplanation: onUpdate,
      onUpdate: onUpdate,
      defaultDescription: defaultDescription,
      children: /*#__PURE__*/_jsxs(Content, {
        direction: "vertical",
        children: [/*#__PURE__*/_jsxs(QuestionTitleContainer, {
          children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
            children: "\u0110\xE1p \xE1n"
          }), /*#__PURE__*/_jsx(QuestionContentTitle, {
            children: "\u0110i\u1EC3m"
          })]
        }), /*#__PURE__*/_jsx(CorrectAnswerListField.List, {
          name: "correctAnswers",
          children: function children(fieldsCorrectAnswer) {
            return /*#__PURE__*/_jsxs(InputArea, {
              direction: "vertical",
              size: "small",
              children: [fieldsCorrectAnswer.map(function (fieldCorrectAnswer, index) {
                var _isDeletingMap$fieldC;

                var isDeleting = (_isDeletingMap$fieldC = isDeletingMap[fieldCorrectAnswer.key]) !== null && _isDeletingMap$fieldC !== void 0 ? _isDeletingMap$fieldC : false;
                return /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsxs(CorrectAnswerListContainer, {
                    children: [/*#__PURE__*/_jsxs(CorrectAnswerItemContainer, {
                      children: [/*#__PURE__*/_jsxs(CorrectAnswerNumber, {
                        children: ["(", fieldCorrectAnswer.key + 1, ")"]
                      }), /*#__PURE__*/_jsx(AnswerDescription, {
                        name: [fieldCorrectAnswer.name, 'answerDescription'],
                        children: /*#__PURE__*/_jsx(TextOptionInput, {
                          disabled: isDisabledInputs,
                          onFocus: function onFocus(e) {
                            return handleAnswerInputFocus(e.target.value, index);
                          },
                          onBlur: function onBlur(e) {
                            return handleAnswerInputBlur(e.target.value, index);
                          },
                          placeholder: defaultDescription,
                          isHiddenAttachment: true,
                          isHiddenDelete: question.correctAnswers.length === 1,
                          onDelete: function onDelete() {
                            onDeleteAnswer(fieldCorrectAnswer.key, 'click');
                            setIsDeletingMap(function (prevIsDeletingMap) {
                              return _objectSpread(_objectSpread({}, prevIsDeletingMap), {}, _defineProperty({}, fieldCorrectAnswer.key, true));
                            });
                          },
                          isDeleting: isDeleting,
                          isUploadFileIconVisible: false
                        })
                      })]
                    }), /*#__PURE__*/_jsx(CorrectAnswerItemContainer, {
                      children: /*#__PURE__*/_jsx(CorrectAnswerListField.Item, {
                        name: [fieldCorrectAnswer.name, 'answerScore'],
                        children: /*#__PURE__*/_jsx(NumberInput, {
                          min: 0,
                          step: "0.25",
                          controls: true,
                          addonAfter: "\u0111i\u1EC3m",
                          stringMode: true,
                          size: "small"
                        })
                      })
                    })]
                  }, fieldCorrectAnswer.key)
                });
              }), createAnswerStatus && createAnswerStatus !== QuizEditStatus.RESET && /*#__PURE__*/_jsx(SpinLayout, {
                children: /*#__PURE__*/_jsx(Spin, {})
              })]
            });
          }
        }), /*#__PURE__*/_jsxs(ButtonAddMoreAnswer, {
          type: "link",
          onClick: onCreateAnswer,
          children: [/*#__PURE__*/_jsx(AddingIcon, {}), "Th\xEAm kho\u1EA3ng tr\u1ED1ng"]
        })]
      })
    }))
  });
};